export default __webpack_public_path__ + "static/media/sundarban2.a1f56209.jpg";